__turbopack_context__.v({
  "bothMarkets": "L3KEwG_bothMarkets",
  "iconCircle": "L3KEwG_iconCircle",
  "offExchange": "L3KEwG_offExchange",
  "onExchange": "L3KEwG_onExchange",
});
